export enum TenantType {
    Radio,
    Pal
}
